import { db } from '../firebase/config';
import { collection, addDoc, doc, updateDoc, getDoc, getDocs, query, where, orderBy, limit, serverTimestamp, setDoc, Timestamp } from 'firebase/firestore';

// Tickets Collection
export const ticketsCollection = collection(db, 'tickets');

// Vendors Collection
export const vendorsCollection = collection(db, 'vendors');

// Locations Collection
export const locationsCollection = collection(db, 'locations');

// Logs Collection
export const logsCollection = collection(db, 'logs');

// Settings Collection
export const settingsCollection = collection(db, 'settings');

// Colección de recargas
export const rechargesCollection = collection(db, 'RechargeInternas');

// Función para registrar una nueva recarga
export const addRecharge = async (rechargeData) => {
  rechargeData.timestamp = serverTimestamp();
  return await addDoc(rechargesCollection, rechargeData);
};

// Función para obtener todas las recargas
export const getRecharges = async () => {
  const q = query(rechargesCollection, orderBy('timestamp', 'desc'));
  return await getDocs(q);
};

// Función para obtener recargas de un vendedor específico
export const getVendorRecharges = async (vendorId) => {
  const q = query(
    rechargesCollection, 
    where('vendorId', '==', vendorId),
    orderBy('timestamp', 'desc')
  );
  return await getDocs(q);
};

// Funciones para gestionar tickets
export const addTicket = async (ticketData) => {
  // Convertir las fechas de JavaScript a Timestamp de Firestore
  if (ticketData.startTime instanceof Date) {
    ticketData.startTime = Timestamp.fromDate(ticketData.startTime);
  }
  
  if (ticketData.endTime instanceof Date) {
    ticketData.endTime = Timestamp.fromDate(ticketData.endTime);
  }
  
  ticketData.createdAt = serverTimestamp();
  ticketData.status = "active";
  return await addDoc(ticketsCollection, ticketData);
};

export const getActiveTickets = async () => {
  const q = query(
    ticketsCollection,
    where("status", "==", "active"),
    orderBy("createdAt", "desc")
  );
  return await getDocs(q);
};

export const getTicketsByPlate = async (plate) => {
  const q = query(
    ticketsCollection,
    where("plate", "==", plate),
    orderBy("createdAt", "desc")
  );
  return await getDocs(q);
};

// Funciones para manejar vendedores
export const addVendor = async (vendorData) => {
  vendorData.createdAt = serverTimestamp();
  vendorData.ticketsSold = 0;
  vendorData.revenueGenerated = 0;
  vendorData.commission = 0;
  vendorData.balance = 0;
  vendorData.status = "active";
  return await addDoc(vendorsCollection, vendorData);
};

export const getVendors = async () => {
  const q = query(vendorsCollection, orderBy('name'));
  return await getDocs(q);
};

export const getActiveVendors = async () => {
  const q = query(
    vendorsCollection,
    where("status", "==", "active"),
    orderBy("name")
  );
  return await getDocs(q);
};

export const updateVendor = async (vendorId, data) => {
  const vendorRef = doc(vendorsCollection, vendorId);
  return await updateDoc(vendorRef, {
    ...data,
    updatedAt: serverTimestamp()
  });
};

export const rechargeVendorBalance = async (vendorId, amount, adminId) => {
  const vendorRef = doc(vendorsCollection, vendorId);
  const vendorSnap = await getDoc(vendorRef);
  
  if (!vendorSnap.exists()) {
    throw new Error('Vendedor no encontrado');
  }
  
  const vendorData = vendorSnap.data();
  const currentBalance = vendorData.balance || 0;
  const newBalance = currentBalance + Number(amount);
  
  return await updateDoc(vendorRef, {
    balance: newBalance,
    lastRecharge: {
      amount: Number(amount),
      date: serverTimestamp(),
      by: adminId
    }
  });
};

// Funciones para gestionar ubicaciones
export const addLocation = async (locationData) => {
  locationData.createdAt = serverTimestamp();
  locationData.currentOccupancy = 0;
  locationData.status = "active";
  return await addDoc(locationsCollection, locationData);
};

export const getActiveLocations = async () => {
  const q = query(
    locationsCollection,
    where("status", "==", "active")
  );
  return await getDocs(q);
};

// Funciones para logs
export const addLog = async (logData) => {
  logData.timestamp = serverTimestamp();
  return await addDoc(logsCollection, logData);
};

export const getUserLogs = async (userId) => {
  const q = query(
    logsCollection,
    where("userId", "==", userId),
    orderBy("timestamp", "desc"),
    limit(100)
  );
  return await getDocs(q);
};

// Funciones para configuración
export const getSettings = async () => {
  const settingsRef = doc(settingsCollection, "general");
  return await getDoc(settingsRef);
};

export const updateSettings = async (settingsData) => {
  const settingsRef = doc(settingsCollection, "general");
  settingsData.updatedAt = serverTimestamp();
  return await updateDoc(settingsRef, settingsData);
};

export const initializeSettings = async (adminUserId) => {
  const settingsRef = doc(settingsCollection, "general");
  const settingsSnapshot = await getDoc(settingsRef);
  
  if (!settingsSnapshot.exists()) {
    await setDoc(settingsRef, {
      hourlyRate: 2.00,
      maxDuration: 2,
      operatingHours: {
        start: "08:00",
        end: "18:00"
      },
      vendorCommission: 0.10,
      updatedAt: serverTimestamp(),
      updatedBy: adminUserId
    });
  }
};
